import { Col, Container, Form, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { REGEX } from "../../utils/utils";
import { connect } from "react-redux";
import { useProductForm } from "../productModalForm";

export const ComercialInfoFormComponent = () => {
  const { isFM, disabled } = useProductForm();

  const {
    register,
    formState: { errors },
    watch
  } = useFormContext();

  const requiredMessage = (field) =>
    isFM ? `El ${field} es obligatorio` : false;

  return (
    <Container>
      <h4>Información comercial</h4>
      <hr />
      <Row>
        <Form.Group as={Col} className="px-3 pb-2" xs={6}>
          <label htmlFor="currency" className="form-label">
            Moneda <span className="text-danger">*</span>
          </label>
          <input
            {...register("currency", {
              required: "El remitente seleccionado no cuenta con una moneda estipulada"
            })}
            id="currency"
            type="text"
            placeholder="Moneda"
            className={`form-control ${!!errors?.currency && "is-invalid"}`}
            readOnly
          />
          {!!errors?.currency && (
            <span className="error-message">
              {errors?.currency?.message || "Este campo es obligatorio"}
            </span>
          )}
        </Form.Group>
        <Form.Group as={Col} className="px-3 pb-2">
          <label htmlFor="pricePerUnit" className="form-label">
            Costo por unidad{isFM && <span className="text-danger">*</span>}
          </label>
          <input
            {...register("pricePerUnit", {
              required: requiredMessage("costo por unidad"),
              pattern: {
                value: REGEX.NUMERIC_WITH_DOC,
                message: "Ingrese un número válido en formato 0.00",
              },
              validate: (value) => {
                if (!isFM) return true;
                return parseFloat(value) > 0 || "El valor debe ser mayor que 0";
              },
            })}
            id="pricePerUnit"
            type="text"
            step="any"
            placeholder="0.00"
            className={`form-control ${!!errors?.pricePerUnit && "is-invalid"}`}
            disabled={disabled || !watch("currency")}
          />
          {!!errors?.pricePerUnit && (
            <span className="error-message">
              {errors?.pricePerUnit?.message || "Este campo es obligatorio"}
            </span>
          )}
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col} className="px-3 pb-2" xs={6}>
          <label htmlFor="price" className="form-label">
            Valor comercial{isFM && <span className="text-danger">*</span>}
          </label>
          <input
            {...register("price", {
              required: requiredMessage("valor comercial"),
              pattern: {
                value: REGEX.NUMERIC_WITH_DOC,
                message: "Ingrese un número válido en formato 0.00",
              },
              validate: (value) => {
                if (!isFM) return true;
                return parseFloat(value) > 0 || "El valor debe ser mayor que 0";
              },
            })}
            id="price"
            type="text"
            step="any"
            placeholder="0.00"
            className={`form-control ${!!errors?.price && "is-invalid"}`}
            disabled={disabled || !watch("currency")}
          />
          {!!errors?.price && (
            <span className="error-message">
              {errors?.price?.message || "Este campo es obligatorio"}
            </span>
          )}
        </Form.Group>
      </Row>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    rowEdited: state.productState.rowEdited,
  };
};

export const ComercialInfoForm = connect(
  mapStateToProps,
)(ComercialInfoFormComponent);
